var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownScroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8011 9.5621L8.48011 13.8047C8.21495 14.0651 7.78505 14.0651 7.51989 13.8047L3.19887 9.5621C2.93371 9.30175 2.93371 8.87964 3.19887 8.61929C3.46403 8.35894 3.89394 8.35894 4.1591 8.61929L7.32102 11.7239L7.32102 2L8.67898 2L8.67898 11.7239L11.8409 8.61929C12.1061 8.35894 12.536 8.35894 12.8011 8.61929C13.0663 8.87964 13.0663 9.30175 12.8011 9.5621Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownScroll);
export default __webpack_public_path__ + "static/media/arrow_down_scroll.1e42badecd3e6308edd44186d0470caa.svg";
export { ForwardRef as ReactComponent };